export const environment = {
    name: 'npd',
    production: false,
    serviceBaseUrls: {
        DOMAIN01: 'https://apis.npd.bfsgodirect.com/app01',
        RedirectDomain: 'https://bfsd.npd.bfsgodirect.com',
        AEMURL: 'https://apis.npu.bfsgodirect.com',
        FinSDKURL:'https://finvu.in/sdk/dev/finvu-client-sdk.js',
        FinLogoList:'/ui-config/finvu-logo-list.json'
    },
        adobeAnalytics: '//assets.adobedtm.com/5fc97671c230/cd5e6eefeb83/launch-a54325503df1-development.min.js',

};

